<template>
  <div class="my-preview-container" v-if="show && question.value?.length">
    <div class="files-container">
      <div class="button-container" v-for="fileItem in question.value" :key="fileItem.name">
        
        <!-- Image Preview -->
        <div v-if="isImage(fileItem)" class="image-container">
          <img :src="fileItem.content" alt="" class="responsive-image">
          <!-- <div class="btn btn--remove" @click="removeFile(fileItem.name)" title="Remove file">X</div> -->
        </div>

        <!-- PDF Preview / Download -->
        <div v-else-if="isPDF(fileItem)" class="pdf-container">
          <span style="color:green"><b>{{ fileItem.name }}</b></span>
          <div class="row">
            <div class="col-12">
              <!-- <div class="btn btn--choose" @click="downloadFile(fileItem)">Download PDF</div>&nbsp; -->
          <!-- <div class="btn btn--remove" @click="removeFile(fileItem.name)">X</div> -->
            </div>
          </div>
          
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import { QuestionFileModel } from "survey-core";

export default {
  name: 'SgbSurveyUiFilePreviewComponent',

  props: {
    question: {
      type: Object,
      required: true
    },
  },

  data() {
    return {
      show: true
    };
  },

  methods: {
    isImage(file) {
      return file.type.startsWith("image/");
    },
    isPDF(file) {
      return file.type === "application/pdf";
    },

    downloadFile(fileItem) {
      fetch(fileItem.content)
        .then((response) => response.blob())
        .then((blob) => {
          const file = new File([blob], fileItem.name, { type: fileItem.type });
          const url = URL.createObjectURL(file);
          const a = document.createElement("a");
          a.href = url;
          a.download = fileItem.name;
          a.click();
          URL.revokeObjectURL(url);
        })
        .catch((error) => console.error("Error:", error));
    },

    removeFile(fileName) {
      this.question.value = this.question.value.filter(f => f.name !== fileName);
      if (!this.question.value.length) this.show = false;
    }
  },
};
</script>

<style scoped>
.my-preview-container {
  margin-top: 2em;
  max-width: calc(100% - 64px);
  margin-bottom: 1em;
  padding-left: 1em;
  padding-right: 1em;
  box-sizing: border-box;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: 0;
}

.button-container {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.image-container {
  width: 200px;
  height: 250px;
  border: 1px solid #ccc;
  border-radius: 6px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  background: #f9f9f9;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.pdf-container {
  width: 400px;
  height: 250px;
  /* border: 1px solid #ccc; */
  /* border-radius: 6px; */
  overflow: hidden;
  display: flex;
  /* flex-direction: column; */
  align-items: center;
  /* justify-content: center; */
  /* position: relative; */
  /* background: #f9f9f9; */
  /* box-shadow: 0 2px 4px rgba(0,0,0,0.1); */
}
/* .pdf-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
} */

.responsive-image {
  width: 100%;
  height: 100%;
  object-fit: cover; /* fills the box while keeping aspect ratio */
}

.btn {
  appearance: none;
  border: 1px solid lightgray;
  cursor: pointer;
  padding: 4px 8px;
  color: var(--sjs-primary-forecolor, var(--primary-foreground, #fff));
  font-weight: 600;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.btn--choose {
  background-color: var(--sjs-primary-backcolor, var(--primary, #19b394));
}

.btn--choose:hover {
  background-color: var(--sjs-primary-backcolor-dark, rgb(20, 164, 139));
}

.btn--remove {
  background-color: var(--sjs-special-red, var(--red, #e60a3e));
}

.btn--remove:hover {
  background-color: rgb(217, 4, 49);
}
</style>
